// extracted by mini-css-extract-plugin
export var active = "_9e-7";
export var container = "_9e-0";
export var evenWidth = "_9e-4";
export var large = "_9e-5";
export var outlet = "_9e-8";
export var slide = "_9e-2";
export var small = "_9e-6";
export var tab = "_9e-3";
export var tabs = "_9e-1";